import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faMedal, faTools, faHeadset, faInfinity, faHandHoldingHeart } from '@fortawesome/free-solid-svg-icons';
import '../../styles/logistic/LogisticGuaranteeSection.css';
import { useTranslation } from 'react-i18next';

const LogisticGuaranteeSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="logistic-guarantee-section">
      <div className="logistic-container">
        <div className="logistic-guarantee-content">
          <div className="logistic-guarantee-badge">
            <FontAwesomeIcon icon={faShieldAlt} />
          </div>
          <h2>{t('LogisticGuaranteeSection:title')}</h2>
          <p className="logistic-guarantee-subtitle">{t('LogisticGuaranteeSection:subtitle')}</p>
          
          <div className="logistic-guarantee-grid">
            <div className="logistic-guarantee-item">
              <div className="logistic-guarantee-icon">
                <FontAwesomeIcon icon={faMedal} />
              </div>
              <h3>{t('LogisticGuaranteeSection:guarantee1_title')}</h3>
              <p>
                {t('LogisticGuaranteeSection:guarantee1_text')}
                <strong>{t('LogisticGuaranteeSection:guarantee1_strong')}</strong>
                {t('LogisticGuaranteeSection:guarantee1_suffix')}
              </p>
            </div>

            <div className="logistic-guarantee-item">
              <div className="logistic-guarantee-icon">
                <FontAwesomeIcon icon={faTools} />
              </div>
              <h3>{t('LogisticGuaranteeSection:guarantee2_title')}</h3>
              <p>
                {t('LogisticGuaranteeSection:guarantee2_text')}
                <strong>{t('LogisticGuaranteeSection:guarantee2_strong')}</strong>
                {t('LogisticGuaranteeSection:guarantee2_suffix')}
              </p>
            </div>

            <div className="logistic-guarantee-item">
              <div className="logistic-guarantee-icon">
                <FontAwesomeIcon icon={faHeadset} />
              </div>
              <h3>{t('LogisticGuaranteeSection:guarantee3_title')}</h3>
              <p>
                {t('LogisticGuaranteeSection:guarantee3_text')}
                <strong>{t('LogisticGuaranteeSection:guarantee3_strong')}</strong>
              </p>
            </div>

            <div className="logistic-guarantee-item">
              <div className="logistic-guarantee-icon">
                <FontAwesomeIcon icon={faInfinity} />
              </div>
              <h3>{t('LogisticGuaranteeSection:guarantee4_title')}</h3>
              <p>
                {t('LogisticGuaranteeSection:guarantee4_text')}
                <strong>{t('LogisticGuaranteeSection:guarantee4_strong')}</strong>
              </p>
            </div>
          </div>

          <div className="logistic-risk-reversal">
            <div className="logistic-risk-content">
              <FontAwesomeIcon icon={faHandHoldingHeart} />
              <div>
                <h3>{t('LogisticGuaranteeSection:risk_reversal_title')}</h3>
                <p>
                  {t('LogisticGuaranteeSection:risk_reversal_text')}
                  <strong>{t('LogisticGuaranteeSection:risk_reversal_strong')}</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogisticGuaranteeSection;